export default __webpack_public_path__ + "static/media/hht2_ep06_timeline_05_blank.4bddc123.png";